// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_g07zM","icon":"index_icon_iHmxj"};